import React, { useState, useEffect, useRef } from 'react';
import {
  SafeAreaView,
  StyleSheet,
  View,
  Text,
  ScrollView,
  Image,
  TouchableOpacity,
  TextInput,
  Alert,
  Modal,
  Video,
  Pressable,
  Linking,
  Clipboard,
  ActivityIndicator,
} from 'react-native';
import { Ionicons } from '@expo/vector-icons';
import { LinearGradient } from 'expo-linear-gradient';

import { Animated } from 'react-native';



const App = ({ navigation }) => {
  const [searchText, setSearchText] = useState('');
  const [userData, setUserData] = useState({});
  const [recentCollabs, setRecentCollabs] = useState([]);
  const [showTutorial, setShowTutorial] = useState(false);
  const [currentStep, setCurrentStep] = useState(0);

  const [modalVisible, setModalVisible] = useState(false);
  const [selectedCollab, setSelectedCollab] = useState(null);

  const [alertCollabs, setAlertCollabs] = useState([]); // Collabs within the timeframe
const [showAlertSymbol, setShowAlertSymbol] = useState(false); // Show alert icon
const [showCollabModal, setShowCollabModal] = useState(false); // Show modal
const [currentCollab, setCurrentCollab] = useState(null); // Selected collab for the modal
const [filteredRecentCollabs, setFilteredRecentCollabs] = useState([]);



const [points, setPoints] = useState(0);
const [showPointsModal, setShowPointsModal] = useState(false);


const animatedScale = new Animated.Value(1);

const [animatedPoints, setAnimatedPoints] = useState(0);


const animatePoints = (targetValue) => {
  let start = 0;
  const duration = 1500;
  const frameDuration = 1000 / 60;
  const totalFrames = Math.round(duration / frameDuration);
  let currentFrame = 0;

  const counter = setInterval(() => {
    currentFrame++;
    const progress = currentFrame / totalFrames;
    const value = Math.round(targetValue * progress);
    setAnimatedPoints(value);

    if (currentFrame === totalFrames) {
      clearInterval(counter);
    }
  }, frameDuration);
};


// Animated sheen for the button
const sheen = useRef(new Animated.Value(0)).current;
useEffect(() => {
  const loop = () => {
    sheen.setValue(0);
    Animated.timing(sheen, {
      toValue: 1,
      duration: 2200,
      useNativeDriver: true,
    }).start(() => loop());
  };
  loop();
  // no cleanup needed for this simple loop
}, []);


const handlePressIn = () => {
  Animated.spring(animatedScale, {
    toValue: 0.9,
    useNativeDriver: true,
  }).start();
};

const handlePressOut = () => {
  Animated.spring(animatedScale, {
    toValue: 1,
    useNativeDriver: true,
  }).start();
};



const FALLBACK_CARD =
  "https://images.pexels.com/photos/1058277/pexels-photo-1058277.jpeg";

const firstImageFromCsv = (value) => {
  if (!value || !String(value).trim()) return FALLBACK_CARD;

  // DB may contain: "url", "url1,url2", or just "url1"
  const first = String(value)
    .split(",")
    .map((s) => s.trim())
    .filter(Boolean)[0];

  return first || FALLBACK_CARD;
};




const logClick = (button) => {
  // Only log if session/user is set
  if (!userData?.Username) return;

  // Optional: include username for redundancy (server can still read session)
  const payload = { button, username: userData.Username };

  try {
    fetch('https://collabbay.com/APIControllers/AnalyseUserActivity.php', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include',
      // keepalive helps on web; harmless elsewhere
      keepalive: true,
      body: JSON.stringify(payload),
    }).catch(() => {});
  } catch (_) {}
};


const [recentOnline, setRecentOnline] = useState([]);
const [recentCount, setRecentCount] = useState(0);

const fetchRecentlyOnline = async () => {
  try {
    const response = await fetch('https://collabbay.com/APIControllers/RecentlyOnlineCreators.php');
    const data = await response.json();
    if (data.status === 'success') {
      setRecentOnline(data.users || []);
      setRecentCount(data.count || 0);
    }
  } catch (error) {
    console.error('Error fetching recently online:', error);
  }
};

useEffect(() => {
  fetchRecentlyOnline();
}, []);


const [modalPage, setModalPage] = useState(1); // Default to page 1

const [loading, setLoading] = useState(true);

useEffect(() => {
  const loadData = async () => {
    setLoading(true); // Start loading
    try {
      await fetchUserData(); // Fetch user data
      await fetchRecentCollabs(); // Fetch recent collabs
      await fetchPoints();

    } catch (error) {
      console.error('Error loading data:', error);
    } finally {
      setLoading(false); // End loading
    }
  };
  loadData();
}, []);



// Parse followers stored as varchar — accepts "5" => 5000, "5k", "12.3k", "8000"
function parseFollowersToInt(raw) {
  if (!raw) return 0;
  const s = String(raw).trim().toLowerCase();
  if (/^\d+(\.\d+)?k$/.test(s)) return Math.round(parseFloat(s) * 1000);
  if (/^\d+(\.\d+)?$/.test(s)) {
    const n = parseFloat(s);
    return n <= 50 ? Math.round(n * 1000) : Math.round(n);
  }
  const d = s.replace(/[^\d.]/g, "");
  return Math.round(parseFloat(d) || 0);
}




const [suggestedOffer, setSuggestedOffer] = useState(null);



const [suggestedImgUri, setSuggestedImgUri] = useState(FALLBACK_CARD);

useEffect(() => {
  // recompute when a new suggestedOffer arrives
  setSuggestedImgUri(firstImageFromCsv(suggestedOffer?.LogoImage));
}, [suggestedOffer]);


const fetchSuggestedOffer = async () => {
  try {
    const response = await fetch('https://collabbay.com/APIControllers/GetSuggestedUserOffer.php', {
      credentials: 'include', // Important for session-based auth if needed
    });
    const data = await response.json();

    if (data.ListingID) {
      setSuggestedOffer(data);
    } else {
      console.log('No suggested offer available.');
    }
  } catch (error) {
    console.error('Error fetching suggested offer:', error);
  }
};

useEffect(() => {
  const loadData = async () => {
    setLoading(true);
    try {
      await fetchUserData();
      await fetchRecentCollabs();
      await fetchSuggestedOffer(); // Add this
    } catch (error) {
      console.error('Error loading data:', error);
    } finally {
      setLoading(false);
    }
  };

  loadData();
}, []);









  const handleCollabPress = (collab) => {
    if (collab.Status === 'RED') {
      setSelectedCollab(collab); // Set the collab for the modal
      setModalVisible(true); // Show the blocking modal
    } else {
      // Open the link directly for YELLOW or other statuses
      Linking.openURL(`https://collabbay.com/UploadPost.html?CollabID=${collab.CollabID}`);
    }
  };
  

  const getCollabStatus = (collab) => {
  const today = new Date();
  const creditAvailableDate = new Date(collab.CreditAvailableStart);

  const timeDiffMs = today - creditAvailableDate;
  const fiveHoursMs = 5 * 60 * 60 * 1000;

  if (collab.Status === 'Cancelled') {
    return 'Cancelled';
  }

  if (collab.Redeemed) {
    return 'Redeemed';
  }

  // ✅ ONLY NEW RULE ADDED
  if (
    collab.Status === 'Accepted' &&
    Math.abs(timeDiffMs) <= fiveHoursMs
  ) {
    return 'Today';
  }

  if (creditAvailableDate < today) {
    return 'Expired';
  }

  return collab.Status === 'Accepted' ? 'Upcoming' : 'Pending';
};

  
const getStatusStyle = (status) => {
  switch (status) {
    case 'Redeemed':
      return styles.redeemedStatus;
    case 'Expired':
      return styles.expiredStatus;
    case 'Today':
      return styles.todayStatus;
    case 'Upcoming':
      return styles.upcomingStatus;
    case 'Pending':
      return styles.pendingStatus;
    case 'Cancelled':
      return styles.cancelledStatus;
    default:
      return null;
  }
};

  
  
  
  useEffect(() => {
    fetchUserData();
    fetchRecentCollabs();
  }, []);

  useEffect(() => {
    console.log("Current step: ", currentStep);
    console.log("Is tutorial showing: ", showTutorial);
  }, [currentStep, showTutorial]);

  const tutorialSteps = [
    {
      message: `Welcome to Collabbay, the platform that connects influencers like you with top brands and unique experiences—from dining to spa days and more. Get access to exclusive offers in exchange for creating engaging content during your visits.`,
      icon: null,
    },
    {
      message: `Browse brand collab offers, find something you like? Simply book a visit and await approval, we'll need to verify you before you can create bookings.`,
      icon: 'search',
    },
    {
      message: `Manage and view upcoming collabs via your calendar, your central manager for tracking upcoming brand collabs at different venues.`,
      icon: 'calendar',
    },
    {
      message: `Each collab has a QR-code card linked to the offer. Instead of paying at venues, present your QR for the brand to scan and redeem your offer. View and manage your QR vouchers via this dashboard.`,
      icon: 'qr-code',
    },
    {
      message: `Your profile is seen by brands, as well as us. Add a profile picture and a bio with your interests.`,
      icon: 'person',
    },
    {
      message: `Welcome to Collabbay, where collabs are your new currency. Update your profile and await a verification message. New venues and offers will be listed on collabbay recurringly.`,
      icon: null,
    },
  ];

  const fetchUserData = async () => {
    try {
 const response = await fetch('https://collabbay.com/APIControllers/GetSessionData.php', {credentials: 'include'});
      const data = await response.json();
      console.log('User Data:', data); // Debugging
  
      setUserData(data);
  
      // Show the verification modal if Status is 'Public Figure' and HasSeenVerifMessage is 0
      if (data.Status === 'Public Figure' && data.HasSeenVerifMessage === "0") {
        setShowVerifModal(true);
      }
  
      // Show the tutorial modal if HasSeenTutorial is 0
      if (data.HasSeenTutorial === "0") {
        setShowTutorial(true);
      }
    } catch (error) {
      console.error('Error fetching user data:', error);
    }
  };
  

const fetchPoints = async () => {
  try {
    const response = await fetch('https://collabbay.com/APIControllers/GetUserPoints.php', {
      credentials: 'include',
    });
    const data = await response.json();
    if (data.success) {
      setPoints(data.points);
      animatePoints(data.points); // 🪄 Animate on load
    }
  } catch (error) {
    console.error('Error fetching Points:', error);
  }
};


const isLoggedIn = !!userData?.Username;
const isPublicFigure = (userData?.Status === 'Public Figure');
const followersInt = parseFollowersToInt(userData?.PlatformFollowers);
const canAccessDirectory = isLoggedIn && isPublicFigure && followersInt >= 5000;

const handleOpenDirectory = () => {
  if (!canAccessDirectory) {
    Alert.alert(
      'Locked',
      !isLoggedIn
        ? 'Please log in to access the Venue Directory.'
        : !isPublicFigure
        ? 'Switch to a creator account (Public Figure) to access the Directory.'
        : `Requires at least 5,000 followers. Current: ${followersInt.toLocaleString()}`
    );
    return;
  }
  logClick('Directory');
  navigation.navigate('UnclaimedSearch');
};


  const [showVerifModal, setShowVerifModal] = useState(false);

const updateHasSeenVerifMessage = () => {
  fetch('https://collabbay.com/APIControllers/UpdateHasSeenVerifMessage.php', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      UserID: userData.UserID,
      HasSeenVerifMessage: 1,
    }),
  })
    .then((response) => response.json())
    .then((data) => {
      if (data.Status === 'Success') {
        setShowVerifModal(false); // Close the modal
      } else {
        console.error('Error updating verification message status: ', data.Message);
      }
    })
    .catch((error) => {
      console.error('Error updating verification message status: ', error);
    });
};

  

  const [filteredCollabs, setFilteredCollabs] = useState([]);


  useEffect(() => {
    const fetchFilteredCollabs = async () => {
      try {
        const response = await fetch('https://collabbay.com/APIControllers/InfluencerGetContentRAG.php');
        const data = await response.json();
  
        if (data.success) {
          const filteredData = data.results.filter(collab => collab.Status === 'RED' || collab.Status === 'YELLOW');
          setFilteredCollabs(filteredData);
  
          // Automatically show the modal if there is a RED status
          const redCollab = filteredData.find(collab => collab.Status === 'RED');
          if (redCollab) {
            setSelectedCollab(redCollab); // Set the collab for the modal
            setModalVisible(true); // Show the modal
          }
        }
      } catch (error) {
        console.error('Error fetching collabs:', error);
      }
    };
  
    fetchFilteredCollabs();
  }, []);

  
  const fetchRecentCollabs = async () => {
    try {
      const response = await fetch('https://collabbay.com/APIControllers/RetrieveRecentCollabs.php');
      const data = await response.json();
      setRecentCollabs(data);
      setFilteredRecentCollabs(data); // Initialize with the full list
    } catch (error) {
      console.error('Error fetching recent collabs: ', error);
    }
  };
  

  const handleSearch = (text) => {
    setSearchText(text);
    if (text.trim() === '') {
      setFilteredRecentCollabs(recentCollabs); // Show all if search is empty
    } else {
      const filtered = recentCollabs.filter((collab) =>
        collab.BrandName.toLowerCase().includes(text.toLowerCase())
      );
      setFilteredRecentCollabs(filtered);
    }
  };
  

  const handlePersonIconPress = () => {
    if (userData.Username) {
      navigation.navigate('UserRecapPage');
    } else {
      navigation.navigate('LogInPage');
    }
  };

  const handleOfferPress = () => {
    navigation.navigate('BrandListings');
  };

  const handleLogout = async () => {
    try {
      const response = await fetch('https://collabbay.com/APIControllers/EndSession.php');
      const data = await response.json();
      if (data.success) {
        Alert.alert('Logout', 'Logout successful');
        navigation.navigate('Homepage');
      } else {
        Alert.alert('Logout', 'No active session found');
      }
    } catch (error) {
      console.error('Error:', error);
    }
  };

  const handleScanIconPress = () => {
    Linking.openURL('https://collabbay.com/QR.html');
  };

  const handleNextStep = () => {
    if (currentStep < tutorialSteps.length - 1) {
      setCurrentStep(currentStep + 1);
    } else {
      updateHasSeenTutorial();  // Update on the server
      setShowTutorial(false);  // Hide the tutorial
    }
  };

  const updateHasSeenTutorial = () => {
    fetch('https://collabbay.com/APIControllers/UpdateHasSeenTutorial.php', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        UserID: userData.UserID,
        HasSeenTutorial: 1,
      }),
    })
      .then(response => response.json())
      .then(data => {
        if (data.Status !== 'Success') {
          console.error('Error updating tutorial status: ', data.Message);
        }
      })
      .catch(error => {
        console.error('Error updating tutorial status: ', error);
      });
  };

  const handleRedoTutorial = () => {
    fetch('https://collabbay.com/APIControllers/RedoTutorial.php', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
    })
      .then(response => response.json())
      .then(data => {
        if (data.Status === 'Success') {
          console.log('Tutorial reset successfully.');
          setCurrentStep(0);  // Reset to the first step
          setShowTutorial(true);  // Make sure tutorial shows again
        } else {
          console.error('Error resetting tutorial status: ', data.Message);
        }
      })
      .catch(error => {
        console.error('Error resetting tutorial status: ', error);
      });
  };

  const checkCollabsInTimeframe = async () => {
    try {
      const response = await fetch(
        'https://collabbay.com/APIControllers/GetCollabCalendarCurrent.php'
      );
      const data = await response.json();
  
      const now = new Date();
      const oneHourBefore = new Date(now.getTime() - 60 * 60 * 1000);
      const fiveHoursAfter = new Date(now.getTime() + 5 * 60 * 60 * 1000);
  
      const filteredCollabs = data.filter((collab) => {
        const collabTime = new Date(collab.CreditAvailableStart);
        return (
          collab.Status === 'Accepted' &&
          collabTime >= oneHourBefore &&
          collabTime <= fiveHoursAfter
        );
      });
  
      if (filteredCollabs.length > 0) {
        setAlertCollabs(filteredCollabs);
        setShowAlertSymbol(true);
      } else {
        setShowAlertSymbol(false);
      }
    } catch (error) {
      console.error('Error fetching collabs:', error);
    }
  };

  useEffect(() => {
    checkCollabsInTimeframe();
  }, []);
  

  const handleAlertPress = () => {
    if (alertCollabs.length > 0) {
      setCurrentCollab(alertCollabs[0]); // Set the first collab in the list
      setShowCollabModal(true);
    }
  };
  
  const handleCollabNavigate = () => {
    setShowCollabModal(false);
    navigation.navigate('CollabCampaignDetailsPage', {
      CollabID: currentCollab.CollabID,
    });
  };
  

  const renderTutorialButton = () => (
    <TouchableOpacity style={styles.redoButton} onPress={handleRedoTutorial}>
       <Ionicons name="help-circle" size={20} color="black" />
    </TouchableOpacity>
  );

  const renderInviteFriendCard = () => {
    if (userData.Status === 'Public Figure') {
      return (
        <TouchableOpacity
          style={{
            position: 'absolute',
            top: 10,
            right: 60,
            backgroundColor: '#f3f3f3',
            padding: 10,
            borderRadius: 20,
            alignItems: 'center',
            flexDirection: 'row',
            zIndex: 10,
          }}
          onPress={() => {
            const inviteLink = `https://collabbay.com/Join?Username=${userData.Username}`;
            Clipboard.setString(inviteLink);
            alert("Invite link copied to clipboard. Max 2 invites.");
          }}
        >
          <Ionicons name="person-add-outline" size={16} color="black" style={{ marginRight: 5, marginLeft: 5 }} />
        </TouchableOpacity>
      );
    }
    return null;
  };
  

  const renderTutorial = () => {
    if (!showTutorial || currentStep >= tutorialSteps.length) {
      return null;
    }

    const step = tutorialSteps[currentStep];

    return (
      <Modal transparent visible={showTutorial} animationType="slide">
        <View style={styles.modalOverlay}>
          <View style={styles.tutorialCard}>
            {step.icon && (
              <Ionicons name={step.icon} size={60} color="black" style={styles.iconLarge} />
            )}
            <Text style={styles.tutorialText}>{step.message}</Text>
            <Pressable style={styles.nextButton} onPress={handleNextStep}>
              <Text style={styles.buttonText}>
                {currentStep < tutorialSteps.length - 1 ? 'Next' : 'Continue'}
              </Text>
            </Pressable>
          </View>
        </View>
      </Modal>
    );
  };

 const isProposalCollab = (collab) =>
  String(collab?.IsProposal || '').toUpperCase() === 'Y';

const proposalCollabs = Array.isArray(filteredRecentCollabs)
  ? filteredRecentCollabs.filter(isProposalCollab)
  : [];

const normalRecentCollabs = Array.isArray(filteredRecentCollabs)
  ? filteredRecentCollabs.filter((collab) => !isProposalCollab(collab))
  : [];
  
  if (loading) {
  return (
    <View style={{ flex: 1, justifyContent: 'center', alignItems: 'center', backgroundColor: '#fff' }}>
      <ActivityIndicator size="large" color="black" />
    </View>
  );
}

  return (
  <View style={{ flex: 1, justifyContent: 'center', alignItems: 'center', backgroundColor: '#fff' }}>
    {/* Yellow strip only at the very top, 600px max width */}
    <View style={{ height: 12, width: '100%', maxWidth: 600, backgroundColor: '#FDF05D', alignSelf: 'center' }} />
    
    <SafeAreaView style={[styles.container, { width: '100%', maxWidth: 600, alignSelf: 'center', backgroundColor: '#fff', flex: 1 }]}>

  <LinearGradient
  colors={['#FDF05D', 'rgba(253,240,93,0)']}
  start={{ x: 0, y: 0 }}
  end={{ x: 0, y: 1 }}
  style={styles.topGlow}
  pointerEvents="none"
/>


  {showVerifModal && (
  <Modal transparent visible={showVerifModal} animationType="slide">
    <View style={styles.modalOverlay}>
      {modalPage === 1 && (
        <View style={styles.modalContent}>
          {/* Page 1: Welcome */}
          <Text style={[styles.modalTitle, { color: 'white' }]}>
            ✨ You're in<Text style={{ color: '#fdf05d' }}>.</Text>
          </Text>
          <Text style={[styles.modalMessage, { color: 'white' }]}>
            <Text style={{ fontWeight: 'bold' }}>
              Content opportunities, comped offers, experiences - the city's your oyster. 
            </Text>
            {"\n"}
            Keep an eye out for new offer drops frequently.
          </Text>
          <TouchableOpacity
            onPress={() => setModalPage(2)}
            style={styles.modalButton}
          >
            <Ionicons name="arrow-forward" size={24} color="black" />
          </TouchableOpacity>
        </View>
      )}
      {modalPage === 2 && (
        <View style={styles.modalContent}>
          {/* Page 2: Invite Friends */}
          <Ionicons name="people-outline" size={60} color="#FDF05D" style={{ marginBottom: 20 }} />
          <Text style={[styles.modalMessage, { color: 'white' }]}>
            <Text style={{ fontWeight: 'bold' }}>
              Because things are more fun together...
            </Text>
            {"\n"}You have unlocked an invite link. Invite up to 2 content-creator friends to join you.
          </Text>
          <TouchableOpacity
            onPress={() => {
              const inviteLink = `https://collabbay.com/Join?Username=${userData.Username}`;
              Clipboard.setString(inviteLink);
              alert("Copied!");
            }}
            style={styles.modalButton}
          >
            <Text style={styles.modalButtonText}>📋 Copy Your Invite Link</Text>
          </TouchableOpacity>
          <TouchableOpacity
            onPress={updateHasSeenVerifMessage}
            style={[styles.modalButton, { backgroundColor: '#fff', marginTop: 10 }]}
          >
            <Text style={{ color: '#000', fontWeight: 'bold' }}>Close</Text>
          </TouchableOpacity>
        </View>
      )}
      {/* Close Button */}
      <TouchableOpacity
        onPress={updateHasSeenVerifMessage}
        style={styles.closeButton}
      >
        <Ionicons name="close-outline" size={30} color="#000" />
      </TouchableOpacity>
    </View>
  </Modal>
)}


<Modal
  visible={!!modalVisible && !!selectedCollab}
  transparent
  animationType="fade"
  onRequestClose={() => {}}
>
  <View style={styles.blockingOverlay}>
    <View style={styles.blockingCard}>
      <View style={{ flexDirection: "row", alignItems: "center", marginBottom: 10 }}>
        <Ionicons name="alert-circle" size={20} color="#FDF05D" />
        <Text style={styles.blockingTitle}>Urgent action required</Text>
      </View>

      <Text style={styles.blockingText}>
        Content for{" "}
        <Text style={{ fontWeight: "800" }}>{selectedCollab?.BrandName}</Text>{" "}
        is overdue. Your account is locked until you upload the content. Please note, section 2.10 in the Terms of Use becomes applicable on undeliverared and or late content. 
      </Text>

      <TouchableOpacity
        onPress={() =>
          Linking.openURL(
            `https://collabbay.com/UploadPost.html?CollabID=${selectedCollab?.CollabID}`
          )
        }
        style={styles.blockingCTA}
        activeOpacity={0.9}
      >
        <Text style={styles.blockingCTAText}>Close and upload pending content</Text>
        <Ionicons name="chevron-forward" size={18} color="#fff" style={{ marginLeft: 8 }} />
      </TouchableOpacity>
    </View>
  </View>
</Modal>


 {renderInviteFriendCard()}
      {renderTutorialButton()}




      <ScrollView contentContainerStyle={styles.contentContainer}>
      <View style={styles.header}>
  <View style={styles.headerRow}>
    {/* Logo */}
    <Image
      style={styles.smallRoundedLogo}
      source={{ uri: 'https://collabbay.com/CollabbayLogoDark.png' }}
    />
    
    {/* Conditionally render 'Hi' text or prompt to log in */}
    {userData.Username ? (
      <Text style={styles.headerText}>Hi 👋, {userData.Username}</Text>
    ) : (
<TouchableOpacity 
  onPress={() => navigation.navigate('LogInPage')}
  style={{ marginBottom: 15 }}
>

        <Text style={styles.headerText}>👋 Time to create.</Text>
      </TouchableOpacity>
    )}
  </View>

  {userData.Username && (
  <TouchableOpacity
    onPress={() => setShowPointsModal(true)}
    style={{
      marginTop: 15,
      alignSelf: 'flex-start',
      backgroundColor: '#000',
      paddingVertical: 6,
      paddingHorizontal: 14,
      borderRadius: 20,
      flexDirection: 'row',
      alignItems: 'center',
      shadowColor: '#000',
      shadowOffset: { width: 0, height: 1 },
      shadowOpacity: 0.1,
      shadowRadius: 3,
      elevation: 3,
    }}
  >
    <Text style={{ fontSize: 16, marginRight: 6 }}>🪙</Text>
   <Text style={{ color: '#FDF05D', fontWeight: 'bold', fontSize: 13 }}>
  {animatedPoints.toLocaleString()} CƵ
</Text>

  </TouchableOpacity>
)}

  

           
  {recentOnline.length > 0 && (
  <View style={styles.recentlyOnlineCard}>
    <Text style={styles.recentlyOnlineLabel}>Recently Online</Text>
    <View style={styles.avatarRow}>
      {recentOnline.slice(0, 3).map((user, index) => (
        <View
          key={index}
          style={[
            styles.avatarWrapper,
            { marginLeft: index === 0 ? 0 : -10, zIndex: 3 - index },
          ]}
        >
          <Image
            source={{ uri: user.ProfileImage }}
            style={styles.avatarImage}
          />
          {index === 0 && <View style={styles.greenDot} />}
        </View>
      ))}
      {recentCount > 3 && (
        <Text style={styles.plusCountText}>+{recentCount - 3}</Text>
      )}
    </View>
  </View>
)}

</View>


        <View style={styles.section}>
          <View style={styles.sectionHeader}>

          {!userData.Username && (
  <TouchableOpacity
    style={styles.signUpButton}
    onPress={() => Linking.openURL('https://collabbay.com/SignUp')}
  >
    <Text style={styles.signUpButtonText}>Sign up as an influencer</Text>
  </TouchableOpacity>
)}




           {!userData.Username && (
  <TouchableOpacity
    style={styles.signUpButtonTwo}
    onPress={() => (window.location.href = 'https://collabbay.com/SignIn')}
  >
    <Text style={styles.signUpButtonTextTwo}>
      <Ionicons name="person" size={12} color="white" /> Log In
    </Text>
  </TouchableOpacity>
)}


          </View> 

          <ScrollView horizontal showsHorizontalScrollIndicator={false}>
  {/* First card with video as background */}
  <View style={styles.card}>
    <video
      autoPlay
      loop
      muted
      playsInline
      style={styles.videoBackground}
    >
      <source src="https://collabbay.com/App%20Video%20-%20Influencer%20Recap.mp4" type="video/mp4" />
    </video>
  </View>

  {/* Other cards with text */}

  <View style={styles.card}>
  <Text style={[styles.venueCodeValue, { fontSize: 35 }]}>
        {new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
      </Text>
    <TouchableOpacity onPress={() => navigation.navigate('CreateSubmissionPage')}>
  <Text style={styles.cardSubTitle}>

</Text>
    </TouchableOpacity>
  </View>

  
  <View style={styles.card}>
    <video
      autoPlay
      loop
      muted
      playsInline
      style={styles.videoBackground}
    >
      <source src="https://collabbay.com/Influencer%20App%20Video%20-%20II.mp4" type="video/mp4" />
    </video>
  </View>





  <View style={styles.card}>
    <Text style={styles.cardTitle}>Create<Text style={{ fontWeight: 'bold', color: '#FDF05D' }}>.</Text></Text>
    <Text style={styles.cardSubTitle}>Go #viral<Text style={{ fontWeight: 'bold', color: '#FDF05D' }}>.</Text></Text>
  </View>
</ScrollView>
       
        </View>

        <View style={styles.offerContainer}>



             
<TouchableOpacity
  onPress={() => (window.location.href = 'https://collabbayadmin.com')}
  style={{
    backgroundColor: '#f3f3f3',
    borderRadius: 20,
    paddingVertical: 7,
    paddingHorizontal: 16,
    alignSelf: 'flex-start',
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 10,
    borderWidth: 1,
    borderColor: '#dcdcdc',
    marginLeft: -15,
    marginTop: -28,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 1 },
    shadowOpacity: 0.1,
    shadowRadius: 3,
    elevation: 2,
  }}
>
  <Text style={{ fontWeight: 'bold', fontSize: 12, color: 'black', marginRight: 6 }}>
    I'm a business
  </Text>
  <Ionicons name="arrow-forward-outline" size={16} color="black" />

</TouchableOpacity>

        <View style={styles.optionContainer}>
  {/* Left: Browse Offers Button */}
<TouchableOpacity
  activeOpacity={0.93}
onPress={() => {
  if (userData.Username) {
    logClick('BrowseOffers');
    handleOfferPress();
  } else {
    window.location.href = 'https://collabbay.com/SignIn';
  }
}}
  style={{
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#FDF05D',
    paddingHorizontal: 18,
    paddingVertical: 14,
    borderRadius: 27,
    flex: 1,
    marginRight: 0,          
    position: 'relative',
    overflow: 'hidden',
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.12,
    shadowRadius: 6,
    elevation: 3,
    width: '99%',           // ⬅️ added
    maxWidth: 600,           // ⬅️ added
    alignSelf: 'center',  
  }}
  accessibilityRole="button"
  accessibilityLabel="Browse brand offers in the marketplace"
>
  <LinearGradient
    colors={['#FDF05D', '#fdf05d', '#fdf05d']}
    start={{ x: 0, y: 0 }}
    end={{ x: 1, y: 1 }}
    style={{
      position: 'absolute',
      inset: 0,
      borderRadius: 30,
      opacity: 0.98,
    }}
    pointerEvents="none"
  />

  <View
    style={{
      width: 30,
      height: 30,
      borderRadius: 15,
      alignItems: 'center',
      backgroundColor: '#fdf05d',
    }}
  >
    <Ionicons name="search" size={21} color="#0b0b0c" />
  </View>

  <View style={{ flex: 1, marginHorizontal: 10 }}>
    <Text style={{ color: '#0b0b0c', fontSize: 22, fontWeight: '690' }}>
      Browse Offers
    </Text>
    <Text style={{ color: '#0b0b0c', opacity: 0.85, fontSize: 10, marginTop: 2 }}>
      Restaurants • Bars • Gyms & more
    </Text>
  </View>

  <View
    style={{
      borderRadius: 12,
      paddingHorizontal: 10,
      paddingVertical: 6,
    }}
  >
    <Ionicons name="chevron-forward" size={32} color="#0b0b0c" />
  </View>
</TouchableOpacity>




  
</View>







          {showAlertSymbol && (  
  <TouchableOpacity onPress={handleAlertPress} style={{ flexDirection: 'row', alignItems: 'center', marginTop: 18 }}>
    <Ionicons name="alert-circle" size={50} color="fdf05d" />
    <Text
  style={{
    marginLeft: 8,
    fontSize: 21,
    color: 'black',
    fontWeight: 'bold', // Fixed typo here
    backgroundColor: '#f3f3f3',
    padding: 9,
    borderRadius: 12, // Rounded border
  }}
>Doing a collab now? Remember to log your visit to avoid being marked as a no-show.
</Text>
    
  </TouchableOpacity>
          )}

{currentCollab && (
  <Modal
    visible={showCollabModal}
    transparent
    animationType="slide"
    onRequestClose={() => setShowCollabModal(false)}
  >
    <View style={styles.modalOverlay}>
      <View style={styles.modalContent}>
        <TouchableOpacity
  onPress={() => setShowCollabModal(false)}
  style={{
    position: 'absolute',
    top: 10,
    right: 10,
    zIndex: 20,
    backgroundColor: 'rgba(0,0,0,0.55)',
    padding: 6,
    borderRadius: 20,
  }}
>
  <Ionicons name="close" size={22} color="#fff" />
</TouchableOpacity>

        {/* Close Button */}
        <TouchableOpacity
          style={styles.closeButton}
          onPress={() => setShowCollabModal(false)}
        >
          <Ionicons name="close" size={24} color="black" />
        </TouchableOpacity>

        {/* Modal Title */}
              <Text style={[styles.modalTitle, { color: 'white' }]}>Are you collabing now?</Text>

        {/* Modal Message */}
          <Text style={[styles.modalMessage, { color: 'white' }]}>
          Enjoy! Just remember to log your visit at {' '}
          <Text style={{ fontWeight: 'bold' }}>{currentCollab.BrandName}</Text>.
        </Text>

        {/* Collab Instructions */}


        {/* Navigate to Collab Button */}
        <TouchableOpacity
          style={styles.modalButton}
          onPress={handleCollabNavigate}
        >
<View style={{ flexDirection: 'row', alignItems: 'center' }}>
  <Text style={styles.modalButtonText}>
    Go to {currentCollab.BrandName} Collab
  </Text>
  <Ionicons
    name="chevron-forward"
    size={20}
    color="#000"
    style={{ marginLeft: 6, marginTop: 1 }}
  />
</View>

        </TouchableOpacity>
      </View>
    </View>
  </Modal>
)}



          {filteredCollabs.length > 0 &&
  filteredCollabs.map((collab, index) => {
    const dueDate = new Date(collab.LatestDeliveryDate);
    const today = new Date();
    const daysLeft = Math.ceil((dueDate - today) / (1000 * 60 * 60 * 24));

    return (
      <TouchableOpacity
        key={index}
        onPress={() => handleCollabPress(collab)}
        style={{
          borderRadius: 10,
          marginTop: 15,
          borderWidth: 2,
          width: '90%',
          borderColor: collab.Status === 'YELLOW' ? '#f2c94c' : '#eb5757',
          backgroundColor: '#f9f9f9',
          padding: 15,
          alignSelf: 'center',
        }}
      >
        <View style={{ alignItems: 'flex-start' }}>
          <Ionicons name="time-outline" size={24} color="black" style={{ marginBottom: 5 }} />
          <Text style={{ fontSize: 20, fontWeight: 'bold', color: '#000', marginBottom: 5 }}>
            {collab.Status === 'YELLOW'
              ? `Pending content due in ${daysLeft} days`
              : 'Urgent action required. Content overdue.'}
          </Text>
          <Text style={{ fontSize: 16, color: '#555' }}>for {collab.BrandName}</Text>
        </View>
      </TouchableOpacity>
    );
  })}



{!userData.Username && ( // Show only if Username is NOT set
  <TouchableOpacity
    onPress={() => (window.location.href = 'https://collabbay.com/SignIn')}
    style={{
      width: '100%',
      alignSelf: 'center',
      marginTop: 5,
    }}
  >
    <Image
      source={{ uri: 'https://collabbay.com/Log%20In%20Button.jpg' }}
      style={{
        width: '100%',
        height: undefined,
        aspectRatio: 1.71,
        resizeMode: 'contain',
      }}
    />
  </TouchableOpacity>
)}



        </View>

        {/* <View style={styles.scanOptionalContainer}>
          <Text>or scan the QR in-venue</Text>
        </View> */}


{userData.Username && proposalCollabs.length > 0 && (
  <View style={styles.proposalInboxSection}>
    <View style={styles.proposalInboxHeader}>
      <View style={styles.proposalInboxBell}>
        <Ionicons name="notifications" size={18} color="#2563eb" />
      </View>

      <View style={{ flex: 1 }}>
        <Text style={styles.proposalInboxTitle}>
          Curated by collabbay™ agents
        </Text>
        <Text style={styles.proposalInboxSub}>
          Our agents matched you with a hand-picked collab proposal.
        </Text>
      </View>
    </View>

    {proposalCollabs.map((collab, index) => {
      const imgUri = firstImageFromCsv(collab.LogoImage);
      const brandDisplay = collab?.OnBehalfOf?.trim()
        ? collab.OnBehalfOf
        : collab.BrandName;

      return (
        <TouchableOpacity
          key={`proposal-${collab.CollabID || index}`}
          style={styles.proposalFeatureCard}
          activeOpacity={0.88}
          onPress={() =>
            navigation.navigate('CollabCampaignDetailsPage', {
              CollabID: collab.CollabID,
            })
          }
        >
          <Image
            source={{ uri: imgUri }}
            style={styles.proposalFeatureImage}
          />

          <LinearGradient
            colors={['rgba(0,0,0,0)', 'rgba(0,0,0,0.94)']}
            start={{ x: 0, y: 0 }}
            end={{ x: 0, y: 1 }}
            style={styles.proposalFeatureOverlay}
          >
            <Text style={styles.proposalFeatureKicker}>
              Curated by collabbay™
            </Text>

            <Text style={styles.proposalFeatureTitle}>
              {brandDisplay}
            </Text>

            <Text style={styles.proposalFeatureDate}>
              {collab.CreditAvailableStart}
            </Text>
          </LinearGradient>

          <View style={styles.proposalNotificationPill}>
            <Ionicons
              name="notifications"
              size={14}
              color="#2563eb"
              style={{ marginRight: 5 }}
            />
            <Text style={styles.proposalNotificationText}>
              Review Your Proposal
            </Text>
          </View>

          <View style={styles.proposalMiniBadge}>
            <Text style={styles.proposalMiniBadgeIcon}>✦</Text>
            <Text style={styles.proposalMiniBadgeText}>Proposal</Text>
          </View>
        </TouchableOpacity>
      );
    })}
  </View>
)}


{userData.Username && suggestedOffer && (
  <View style={{ marginBottom: 20, width: '100%' }}>
    {/* TITLE */}
    <Text style={{
  fontSize: 22,
  fontWeight: 'bold',
  color: '#000',
  marginBottom: 15,
  marginLeft: 1, // fixed typo: "maginLeft" ➡️ "marginLeft"
  padding: 10,
  borderRadius: 15,
  textAlign: 'left'
}}>
✨ For you, <Text style={{ fontWeight: 'bold' }}>{userData.Username}</Text><Text style={{ color: '#fdf05d' }}>.</Text>
</Text>



    {/* CARD */}
    <TouchableOpacity
      style={styles.suggestedCard}
      onPress={() => navigation.navigate('CreateSubmissionPage', { ListingID: suggestedOffer.ListingID })}
      activeOpacity={0.8}
    >
      {/* STAR ICON TOP RIGHT */}
      <Ionicons
        name="star"
        size={24}
        color="white"
        style={{
          position: 'absolute',
          top: 21,
          right: 26,
          zIndex: 10,
        }}
      />

      {/* IMAGE */}
      <Image
  source={{ uri: suggestedImgUri }}
  style={styles.suggestedCardImage}
  onError={() => setSuggestedImgUri(FALLBACK_CARD)}
/>


      {/* CARD CONTENT */}
      <View style={styles.suggestedCardContent}>
<Text style={styles.suggestedBrandName}>
  {suggestedOffer?.OnBehalfOf?.trim() ? suggestedOffer.OnBehalfOf : suggestedOffer?.BrandName}
</Text>


        <Text style={styles.suggestedDescription}>
          {suggestedOffer.ListingDescription.length > 50
            ? suggestedOffer.ListingDescription.substring(0, 80) + '...'
            : suggestedOffer.ListingDescription}
        </Text>

        <View style={styles.creditsBadge}>
          <Text style={styles.creditsBadgeText}>£{suggestedOffer.Credits} Value</Text>
        </View>

        <Text style={styles.suggestedLocation}>📍 {suggestedOffer.Location}</Text>
      </View>
    </TouchableOpacity>
  </View>
)}




{/* {userData?.Username && userData?.Status === 'Public Figure' && (
  <TouchableOpacity
    activeOpacity={0.96}
    onPress={handleOpenDirectory}   // <-- logs + navigates (if allowed)
    style={styles.directoryCard}
    accessibilityRole="button"
    accessibilityLabel="Open Venue Directory"
  > */}
    {/* Soft glass wash */}
    {/* <LinearGradient
      colors={['rgba(255,255,255,0.45)', 'rgba(255,255,255,0.14)']}
      start={{ x: 0, y: 0 }}
      end={{ x: 1, y: 1 }}
      style={styles.directoryGlass}
      pointerEvents="none"
    /> */}

    {/* Subtle top sheen */}
    {/* <LinearGradient
      colors={['rgba(255,255,255,0.5)', 'rgba(255,255,255,0.0)']}
      start={{ x: 0, y: 0 }}
      end={{ x: 0, y: 1 }}
      style={styles.directoryTopSheen}
      pointerEvents="none"
    /> */}

    {/* ✨ NEW badge (yellow, top-right) */}
    {/* <View style={styles.newBadge}>
      <Text style={styles.newBadgeText}>✨ NEW</Text>
    </View> */}

    {/* Book emoji with tiny shadow */}
    {/* <View style={styles.emojiWrap}>
      <Text style={styles.dirEmoji}>📖</Text>

{/* <View style={{ marginLeft: 10 }}>
  <Text style={styles.dirTitle}>Venue Directory</Text>
  <Text style={styles.dirSub}>A new tool for you.</Text>
</View> */}

  {/* </TouchableOpacity>
)} */}

        <View style={styles.bottomBackground}>
          {/* <TouchableOpacity onPress={handleScanIconPress}>
            <Ionicons name="scan" size={200} color="black" style={styles.qrIcon} />
          </TouchableOpacity> */}

          <View style={styles.searchBar}>
            <Ionicons name="search" size={24} color="" style={styles.searchIcon} />
            <TextInput
  style={styles.searchInput}
  placeholder="Search my recent collabs..."
  placeholderTextColor="#333333"
  onChangeText={handleSearch}
/>

          </View>


{userData.Username && normalRecentCollabs.length > 0 && (
  <View style={styles.section}>
    <Text style={styles.sectionTitle}>My Recent Collabs</Text>


{normalRecentCollabs.map((collab, index) => {
  const collabStatus = getCollabStatus(collab);
  const imgUri = firstImageFromCsv(collab.LogoImage);
  
      return (
        <TouchableOpacity
          key={index}
          style={styles.recentCardModern}
          onPress={() =>
            navigation.navigate('CollabCampaignDetailsPage', {
              CollabID: collab.CollabID,
            })
          }
        >
          {/* IMAGE */}
          <Image source={{ uri: imgUri }} style={styles.recentCardImage} />

          {/* OVERLAY */}
          <LinearGradient
  colors={['rgba(0,0,0,0)', 'rgba(0,0,0,0.92)']}
  start={{ x: 0, y: 0 }}
  end={{ x: 0, y: 1 }}
  style={styles.recentOverlay}
>

            <Text style={styles.recentTitle}>
              {collab?.OnBehalfOf?.trim()
                ? collab.OnBehalfOf
                : collab.BrandName}
            </Text>

            <Text style={styles.recentSubtitle}>
              {collab.CreditAvailableStart}
            </Text>
          </LinearGradient>

{/* STATUS BADGE */}
<View style={[styles.recentStatusBadge, getStatusStyle(collabStatus)]}>
  <Text style={styles.recentStatusText}>{collabStatus}</Text>
</View>
</TouchableOpacity>
      );
    })}
  </View>
)}




           </View>
      </ScrollView>

      <TouchableOpacity 
  onPress={() => Linking.openURL('https://collabbay.com/PrivacyPolicy.html')}
  style={{
    marginTop: 7, 
    marginBottom: 7
  }}
>
  <Text style={{ fontSize: 12, color: 'black', textDecorationLine: 'underline', textAlign: 'center' }}>
    By using collabbay, you agree to our Privacy Policy.
  </Text>
</TouchableOpacity>

      <View style={styles.footer}>
        <TouchableOpacity style={styles.footerIcon} onPress={() => navigation.navigate('Homepage')}>
          <Ionicons name="home" size={24} color="black" />
        </TouchableOpacity>


        <TouchableOpacity style={styles.footerIcon} onPress={() => navigation.navigate('CollabCalendar')}>
          <Ionicons name="calendar" size={24} color="black" />
        </TouchableOpacity>





  {userData.Username ? (
<TouchableOpacity
  onPress={() => navigation.navigate('MyFeed')}
  style={{
    backgroundColor: "#fdf05d",
    padding: 10,
    borderRadius: 20,
  }}
>
  <Ionicons name="film-outline" size={22} color="black" />
</TouchableOpacity>
) : (
<TouchableOpacity
 onPress={() => (window.location.href = 'https://collabbay.com/SignIn')}
  style={{
    backgroundColor: "#fdf05d",
    padding: 10,
    borderRadius: 20,
  }}
>
  <Ionicons name="film-outline" size={22} color="black" />
</TouchableOpacity>
)}

        
        <TouchableOpacity
    style={styles.footerIcon}
    onPress={() => navigation.navigate('UserActivityFeed')}
  >
    <Ionicons name="chatbox-ellipses-outline" size={24} color="black" />
  </TouchableOpacity>

  {userData.Username ? (
  <TouchableOpacity style={styles.footerIcon} onPress={handlePersonIconPress}>
    <Ionicons name="person" size={24} color="black" />
  </TouchableOpacity>
) : (
  <TouchableOpacity
    style={styles.footerIcon}
    onPress={() => (window.location.href = 'https://collabbay.com/SignIn')}
  >
    <Ionicons name="person" size={24} color="black" />
  </TouchableOpacity>
)}

      </View>

      {renderTutorial()}
      


{/* === CƵ POINTS MODAL === */}
<Modal
  visible={showPointsModal}
  transparent
  animationType="slide"
  onRequestClose={() => setShowPointsModal(false)}
>
  <View style={[styles.modalOverlay, { backgroundColor: 'rgba(0,0,0,0.85)' }]}>

    {/* 🔥 Added ScrollView so content can scroll */}
    <ScrollView contentContainerStyle={{ alignItems: 'center', paddingVertical: 30 }}>

      <View
        style={{
          margin: 20,
          backgroundColor: '#000',
          borderRadius: 16,
          padding: 25,
          alignItems: 'center',
          shadowColor: '#000',
          shadowOffset: { width: 0, height: 2 },
          shadowOpacity: 0.25,
          shadowRadius: 4,
          elevation: 5,
          maxWidth: 600,
          width: '90%',
        }}
      >
        {/* TITLE */}
        <View style={{ marginBottom: 15 }}>
          <Text style={{ color: 'white', fontSize: 23, fontWeight: '600', textAlign: 'center' }}>
            ✨ What are CƵ?
          </Text>
          <Text
            style={{
              color: 'white',
              fontSize: 13,
              fontWeight: '300',
              textAlign: 'center',
              letterSpacing: 2,
              textTransform: 'uppercase',
            }}
          >
            collabbay coinz
          </Text>
        </View>

        {/* VIDEO */}
        <View
          style={{
            width: '100%',
            borderRadius: 12,
            overflow: 'hidden',
            marginBottom: 20,
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <video
            autoPlay
            loop
            muted
            playsInline
            style={{ width: '44%', height: 'auto', borderRadius: 12 }}
          >
            <source
              src="https://collabbay.com/CZ%20Currency%20Release.mp4"
              type="video/mp4"
            />
          </video>
        </View>

        {/* GRID — HOW TO EARN */}
        <View
          style={{
            width: '100%',
            marginBottom: 20,
          }}
        >
          <Text
            style={{
              color: '#fff',
              fontSize: 14,
              fontWeight: '700',
              marginBottom: 10,
              textAlign: 'center',
            }}
          >
            Earn CƵ by doing what you already love 🚀
          </Text>

          <View
            style={{
              flexDirection: 'row',
              flexWrap: 'wrap',
              justifyContent: 'space-between',
            }}
          >
            {[
              { action: 'Book an offer', points: '+120 CƵ' },
              { action: 'Invite a friend', points: '+50 CƵ' },
              { action: ' Use the venue directory', points: '+90 CƵ' },
              { action: 'Upload content early', points: '+60 CƵ' },
            ].map((item, idx) => (
              <View
                key={idx}
                style={{
                  width: '48%',
                  backgroundColor: '#1a1a1a',
                  paddingVertical: 12,
                  paddingHorizontal: 8,
                  borderRadius: 10,
                  marginBottom: 10,
                }}
              >
                <Text
                  style={{
                    color: '#FDF05D',
                    fontSize: 15,
                    fontWeight: '700',
                    textAlign: 'center',
                  }}
                >
                  {item.points}
                </Text>
                <Text
                  style={{
                    color: '#fff',
                    fontSize: 13,
                    textAlign: 'center',
                    marginTop: 4,
                  }}
                >
                  {item.action}
                </Text>
              </View>
            ))}
          </View>
        </View>

        {/* DESCRIPTION */}
        <Text
          style={{
            color: '#ccc',
            fontSize: 14,
            textAlign: 'center',
            marginBottom: 25,
            lineHeight: 20,
          }}
        >
          Trade your CƵ for payouts, exclusive perks and access, and V-VIP opportunities.
          {'\n'}More exciting ways to use your CƵ coming soon…
        </Text>

        {/* CLOSE BUTTON */}
        <TouchableOpacity
          style={{
            backgroundColor: '#FDF05D',
            paddingVertical: 12,
            paddingHorizontal: 30,
            borderRadius: 30,
          }}
          onPress={() => setShowPointsModal(false)}
        >
          <Text style={{ color: '#000', fontWeight: 'bold', fontSize: 15 }}>Got it</Text>
        </TouchableOpacity>
      </View>
    </ScrollView>
    {/* 🔥 End ScrollView */}

  </View>
</Modal>


      
    </SafeAreaView>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: '#fff',
  },
  contentContainer: {
    paddingHorizontal: 10,
  },
  bannerContainer: {
    marginBottom: 20,
    borderRadius: 10,
    marginTop: 20,
    backgroundColor: 'black',
    width: '100%',
    height: 80,
  },
  bannerImage: {
    width: '100%',
    height: '100%',
    borderRadius: 10,
  },
  searchBar: {
    backgroundColor: '#f3f3f3',
    borderRadius: 20,
    flexDirection: 'row',
    alignItems: 'center',
    paddingHorizontal: 15,
    paddingVertical: 10,
    marginTop: 40,
    marginBottom: 10,
    borderColor: '#ededed',
    borderWidth: 1,

  },
  searchInput: {
    flex: 1,
    color: 'black',
    fontSize: 16,
    marginLeft: 10,
  },
  section: {
    marginBottom: 20,
  },
  sectionTitle: {
    fontSize: 15,
    fontWeight: 'bold',
    marginBottom: 10,
  },
  sectionTitleCollabs: {
    fontSize: 15,
    fontWeight: 'bold',
    marginBottom: 10,
    color: 'white',
  },
  card: {
    width: 157,
    height: 187,
    backgroundColor: 'black', // Fallback color in case the video fails
    marginRight: 10,
    borderRadius: 14,
    justifyContent: 'center',
    alignItems: 'center',
    position: 'relative', // Ensures that the video fills the entire card
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 1 },
    shadowOpacity: 0.2,
    shadowRadius: 5,

    // Elevation for Android
    elevation: 4,
  },
  videoBackground: {
    position: 'absolute', // Position the video inside the card only
    top: 0,
    left: 0,
    width: '100%', // Ensure the video covers the entire width of the card
    height: '100%', // Ensure the video covers the entire height of the card
    borderRadius: 10, // Keep the border radius of the card
    zIndex: 0, // Ensure the video stays behind the text
  },
  cardTitle: {
    fontSize: 19,
    fontWeight: 'bold',
    color: 'white',
    fontSize: 11,
    textAlign: 'center',
    zIndex: 1, // Ensure text is above video (not needed here since there's no text)
  fontSize: 15,
  },
  cardSubTitle: {
    color: 'white',
    marginTop: 5,
    textAlign: 'center',
    zIndex: 1, // Ensure subtitle is above video (not needed here since there's no text)
  },
  collabCard: {
    backgroundColor: 'white',
    borderRadius: 19,
    padding: 12,
    marginBottom: 10,
  },
  collabCardTitle: {
    fontSize: 18,
    fontWeight: 'bold',
  },
  collabCardSubTitle: {
    fontSize: 15,
    color: 'gray',
  fontWeight: 'bold',
  },
  qrIcon: {
    alignSelf: 'center',
    marginTop: 20,
  },
  redoButton: {
    position: 'absolute',
    top: 10,
    right: 10,
    backgroundColor: '#FDF05D',
    padding: 6,
    borderRadius: 20,
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 10,
  },
  footer: {
    flexDirection: 'row',
    justifyContent: 'space-around',
    position: 'sticky',
    bottom: 0,
    backgroundColor: 'white',
    left: 0,
    right: 0,
    paddingVertical: 10,
  },
  footerIcon: {
    alignItems: 'center',
  },
  bottomBackground: {
    backgroundColor: '#fdf05d',
    borderTopLeftRadius: 30,
    borderBottomLeftRadius: 15,
    borderTopRightRadius: 30,
    borderBottomRightRadius: 15,
    paddingHorizontal: 10,
    paddingBottom: 120,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 1 },
    shadowOpacity: 0.1,
    shadowRadius: 5,

    // Elevation for Android
    elevation: 2,
  },
  sectionHeader: {
    flexDirection: 'row',
    
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: 10,
  },
  signUpButton: {
    backgroundColor: '#FDF05D',
    paddingVertical: 10,
    paddingHorizontal: 20,
    borderRadius: 20,
    borderColor: 'black',
  },
  signUpButtonTwo: {
    backgroundColor: 'black',
    paddingVertical: 10,
    paddingHorizontal: 20,
    borderRadius: 20,
    borderWidth: 1,
    borderColor: 'black',
  },
  signUpButtonText: {
    color: 'black',
    fontSize: 14,
    fontWeight: 'bold',
  },
  signUpButtonTextTwo: {
    color: 'white',
    fontSize: 14,
    fontWeight: 'bold',
  },
  offerIcon: {
    marginRight: 5,
    marginLeft: 6,
  },
  offerText: {
    color: 'black',
    fontSize: 16,
    fontWeight: 'bold',
  },
  offerLogText: {
    color: 'black',
    fontSize: 12,
    fontWeight: 'bold',
  },
  offerContainer: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    padding: 20,
  },
  scanOptionalContainer: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    padding: 20,
  },
  modalOverlay: {
    flex: 1,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    justifyContent: 'center',
    alignItems: 'center',
  },
  tutorialCard: {
    backgroundColor: 'white',
    padding: 20,
    borderRadius: 10,
    alignItems: 'center',
    width: '80%',
  },
  iconLarge: {
    marginBottom: 15,
  },
  tutorialText: {
    fontSize: 16,
    textAlign: 'center',
    marginBottom: 10,
  },
  nextButton: {
    marginTop: 10,
    padding: 10,
    backgroundColor: '#000',
    borderRadius: 5,
  },
  buttonText: {
    color: 'white',
    fontWeight: 'bold',
  },
  linkText: {
    fontSize: 9,
    color: 'black',
    textDecorationLine: 'underline',
    textAlign: 'center',
  },

  header: {
    width: '100%',
    paddingTop: 20,
    paddingBottom: 10,
    paddingHorizontal: 2,
    backgroundColor: 'transparent', // Optional: background color for header
  },

  headerRow: {
    flexDirection: 'row', // Align logo and text horizontally
    alignItems: 'center', // Center items vertically
    justifyContent: 'flex-start', // Align items to the left
    width: '100%',
  },

  smallRoundedLogo: {
    width: 40, // Small logo size
    height: 40,
    borderRadius: 20, // Fully rounded
    backgroundColor: 'black', // Optional: background color if logo has transparency
    marginRight: 10, // Space between logo and text
  },

  headerText: {
    fontSize: 23, // Adjust text size
    fontWeight: 'bold',
    paddinTop: 8,
    color: 'black', // Text color
    textAlign: 'left', // Align text to the left
    flex: 1, // Allow text to take remaining space
  },
  modalContent: {
    backgroundColor: '#fff',
    padding: 20,
    borderRadius: 10,
    alignItems: 'center',
    width: '80%',
  },
  modalTitle: {
    fontSize: 18,
    fontWeight: 'bold',
    marginBottom: 10,
  },
  modalMessage: {
    fontSize: 16,
    textAlign: 'center',
    marginBottom: 20,
  },
  modalButton: {
    backgroundColor: '#fdf05d',
    padding: 10,
    borderRadius: 5,
  },
  modalButtonText: {
    color: '#black',
    fontWeight: 'bold',
    fontSize: 16,
  },
  expiredStatus: {
    color: 'black',
    backgroundColor: 'grey',
    paddingHorizontal: 10,
    paddingVertical: 5,
    borderRadius: 12,
  },
  redeemedStatus: {
    color: 'white',
    backgroundColor: 'green',
    paddingHorizontal: 10,
    paddingVertical: 5,
    borderRadius: 12,
  },
  upcomingStatus: {
    color: 'black',
    backgroundColor: 'lightgreen',
    paddingHorizontal: 10,
    paddingVertical: 5,
    borderRadius: 12,
  },
  pendingStatus: {
    color: 'black',
    backgroundColor: 'yellow',
    paddingHorizontal: 10,
    paddingVertical: 5,
    borderRadius: 12,
  },
  cancelledStatus: {
    backgroundColor: 'red',
    paddingHorizontal: 10,
    color: 'white',
    paddingVertical: 5,
    borderRadius: 12,
  },
  statusBadge: {
    position: 'absolute',
    top: 7,
    right: 7,
    borderRadius: 12,
    paddingHorizontal: 10,
    paddingVertical: 5,
  },
  statusText: {
    color: 'black',
    fontWeight: 'bold',
    fontSize: 12,
  },

  loadingContainer: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: '#fff', // Optional background color
},
modalContent: {
  backgroundColor: '#000',
  padding: 20,
  borderRadius: 10,
  alignItems: 'center',
  width: '80%',
},
optionContainer: {
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'center',
  width: '100%', // Ensures full-width usage on mobile web
  paddingHorizontal: 10,
  marginTop: 3,
},

offerButton: {
  flexDirection: 'row',
  alignItems: 'center',
  backgroundColor: '#FDF05D',
  paddingHorizontal: 15,
  paddingVertical: 12,
  borderRadius: 30,
  flex: 1,
  justifyContent: 'center',
  marginRight: 10,

  // needed for the gradient sheen
  position: 'relative',
  overflow: 'hidden',

  shadowColor: '#000',
  shadowOffset: { width: 0, height: 2 },
  shadowOpacity: 0.1,
  shadowRadius: 4,
  elevation: 3,
},

directoryButton: {
  width: 55,
  height: 55,
  backgroundColor: 'black',
  justifyContent: 'center',
  alignItems: 'center',
  borderRadius: 50,
  shadowColor: '#000',
  shadowOffset: { width: 0, height: 2 },
  shadowOpacity: 0.2,
  shadowRadius: 5,
  elevation: 4,
},
directoryText: {
  color: 'black',
  fontSize: 13,
  fontWeight: 'bold',
  textAlign: 'center',
  marginTop: 5, // Space between button and text
},
suggestedCard: {
  backgroundColor: '#f3f3f3', // Softer background
  borderRadius: 20,           // More rounded
  padding: 15,
  marginBottom: 10,
  shadowColor: '#000',
  shadowOffset: { width: 0, height: 2 },
  shadowOpacity: 0.1,
  shadowRadius: 10,
  elevation: 5,
  width: '100%',
  maxWidth: 600,
  alignSelf: 'center',
  position: 'relative',       // For the star icon absolute position
},

suggestedCardImage: {
  width: '100%',
  height: 150,
  borderRadius: 15,
  marginBottom: 10,
  resizeMode: 'cover',
  backgroundColor: '#000',
},
recentCardModern: {
  width: '100%',
  height: 160,
  borderRadius: 18,
  marginBottom: 15,
  overflow: 'hidden',
  backgroundColor: '#000',
  position: 'relative',
  maxWidth: 600,
  alignSelf: 'center',
},

recentCardImage: {
  width: '100%',
  height: '100%',
  borderRadius: 18,
  resizeMode: 'cover',
},

recentOverlay: {
  position: 'absolute',
  bottom: 0,
  left: 0,
  right: 0,
  paddingHorizontal: 12,
  paddingVertical: 19,
},

recentTitle: {
  color: '#fff',
  fontSize: 21,
  fontWeight: '720',
},

recentSubtitle: {
  color: '#ddd',
  fontSize: 14,
  marginTop: 3,
  fontWeight: '500',
},

recentStatusBadge: {
  position: 'absolute',
  top: 10,
  right: 10,
  paddingHorizontal: 10,
  paddingVertical: 5,
  borderRadius: 12,
  backgroundColor: 'rgba(255,255,255,0.85)',
},

recentStatusText: {
  fontSize: 11,
  fontWeight: '700',
  color: '#000',
},


suggestedCardContent: {
  flexDirection: 'column',
  alignItems: 'flex-start',
},

suggestedBrandName: {
  fontSize: 20,
  fontWeight: 'bold',
  color: '#000',
  marginBottom: 8,
},

suggestedDescription: {
  fontSize: 14,
  color: '#555',
  marginBottom: 12,
},

creditsBadge: {
  backgroundColor: '#fdf05d',
  borderRadius: 12,
  paddingHorizontal: 10,
  paddingVertical: 6,
  marginBottom: 10,
},

creditsBadgeText: {
  fontSize: 14,
  color: '#000',
  fontWeight: '550',
},

suggestedLocation: {
  fontSize: 14,
  color: '#000',
},

recentlyOnlineCard: {
  backgroundColor: '#f3f3f3',
  borderRadius: 23,
  padding: 10,
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'flex-start',
  width: '51%',
  marginLeft: '49%',
  marginBottom: 10,
  shadowColor: '#000',
  shadowOffset: { width: 0, height: 1 },
  shadowOpacity: 0.1,
  shadowRadius: 2,
  zIndex: 5,
},

recentlyOnlineLabel: {
  fontSize: 10,
  paddingLeft: 5,
  color: '#333',
  fontWeight: '600',
  marginRight: 10,
},

avatarRow: {
  flexDirection: 'row',
  alignItems: 'center',
},

avatarWrapper: {
  width: 30,
  height: 30,
  borderRadius: 15,
  overflow: 'visible',
  position: 'relative',
  backgroundColor: '#ddd',
},

avatarImage: {
  width: 30,
  height: 30,
  borderRadius: 15,
},

greenDot: {
  width: 10,
  height: 10,
  borderRadius: 5,
  backgroundColor: '#4CD964',
  position: 'absolute',
  top: 0,
  left: -4,
  borderWidth: 2,
  borderColor: '#fff',
  zIndex: 999,
},

plusCountText: {
  marginLeft: 8,
  fontSize: 12,
  color: '#555',
  fontWeight: 'bold',
},
offerCtaCard: {
  flex: 1,
  position: 'relative',
  backgroundColor: 'rgba(16,16,20,0.85)', // glassy dark
  borderRadius: 18,
  padding: 14,
  marginRight: 10, // space from the directory button
  overflow: 'hidden',
  borderWidth: 1,
  borderColor: 'rgba(255,255,255,0.06)',
  shadowColor: '#000',
  shadowOffset: { width: 0, height: 8 },
  shadowOpacity: 0.2,
  shadowRadius: 20,
  elevation: 6,
},
offerCtaHalo: {
  ...StyleSheet.absoluteFillObject,
},
offerCtaIconWrap: {
  width: 32,
  height: 32,
  borderRadius: 16,
  backgroundColor: '#FDF05D',
  borderWidth: 1,
  borderColor: '#0b0b0c',
  alignItems: 'center',
  justifyContent: 'center',
},
offerCtaTitle: {
  color: '#fff',
  fontSize: 16,
  fontWeight: '800',
},
offerCtaSub: {
  color: '#d6d6d6',
  fontSize: 12,
  marginTop: 2,
},
offerCtaGo: {
  backgroundColor: '#FDF05D',
  borderRadius: 12,
  paddingHorizontal: 10,
  paddingVertical: 6,
  borderWidth: 1,
  borderColor: '#0b0b0c',
},
offerButtonGradient: {
  ...StyleSheet.absoluteFillObject,
  borderRadius: 30,  // matches your pill
  opacity: 0.95,     // slightly richer yellow
},
todayStatus: {
  color: 'black',
  backgroundColor: '#FDF05D',
  paddingHorizontal: 10,
  paddingVertical: 5,
  borderRadius: 12,
},


venueCodeValue: {
  fontSize: 50,
  fontWeight: 'bold',
  color: '#fff',
  textAlign: 'center',
},
topGlow: {
  position: 'absolute',
  top: 0,
  left: 0,
  right: 0,
  height: 90,   // 90px tall
  zIndex: -1,   // keep it behind everything
},

directoryCard: {
  marginTop: 6,                      // smaller top margin
  width: '92%',
  maxWidth: 440,                    // thinner than before
  alignSelf: 'center',
  borderRadius: 18,
  paddingVertical: 14,
  paddingHorizontal: 16,
  overflow: 'hidden',
  position: 'relative',
  flexDirection: 'row',             // make horizontal layout
  alignItems: 'center',
  justifyContent: 'flex-start',     // align left
  backgroundColor: 'rgba(255,255,255,0.22)',
  borderWidth: 1,
  borderColor: 'rgba(0,0,0,0.06)',
  shadowColor: '#000',
  shadowOffset: { width: 0, height: 3 },
  shadowOpacity: 0.10,
  shadowRadius: 8,
  marginBottom: 9,
  marginTop: 9,
  elevation: 3,
},

directoryGlass: {
  ...StyleSheet.absoluteFillObject,
  borderRadius: 18,
},

directoryTopSheen: {
  position: 'absolute',
  top: 0,
  left: 0,
  right: 0,
  height: 28,
  borderTopLeftRadius: 18,
  borderTopRightRadius: 18,
},

newBadge: {
  position: 'absolute',
  top: 8,
  right: 10,
  backgroundColor: '#FDF05D',  // yellow badge
  paddingHorizontal: 10,
  paddingVertical: 4,
  borderRadius: 12,
  borderWidth: 1,
  borderColor: 'rgba(0,0,0,0.18)',
},

newBadgeText: {
  color: '#0b0b0c',
  fontSize: 10,
  fontWeight: '800',
  letterSpacing: 0.3,
},

emojiWrap: {
  alignItems: 'center',
  justifyContent: 'center',
  marginBottom: 4,         // tighter spacing
  position: 'relative',
},

dirEmoji: {
  fontSize: 32,            // smaller than before
  lineHeight: 34,
},

emojiShadow: {
  position: 'absolute',
  bottom: -3,
  width: 30,
  height: 6,
  borderRadius: 4,
  backgroundColor: 'rgba(0,0,0,0.18)',
  alignSelf: 'center',
  transform: [{ scaleX: 1.35 }],
},

dirTitle: {
  marginTop: 2,
  fontSize: 13,     // smaller title
  fontWeight: '700',
  color: '#0b0b0c',
},

dirSub: {
  marginTop: 1,
  fontSize: 10,     // smaller subtitle
  color: '#333',
  opacity: 0.85,
},

overdueBannerWrap: {
  position: "absolute",
  top: 0,
  left: 0,
  right: 0,
  zIndex: 999,
  paddingHorizontal: 10,
  paddingTop: 10,
},

overdueBannerCard: {
  backgroundColor: "#0b0b0c",
  borderRadius: 18,
  padding: 14,
  borderWidth: 2,
  borderColor: "#eb5757",
  shadowColor: "#000",
  shadowOffset: { width: 0, height: 4 },
  shadowOpacity: 0.18,
  shadowRadius: 10,
  elevation: 6,
},

overdueCloseBtn: {
  position: "absolute",
  top: 10,
  right: 10,
  width: 28,
  height: 28,
  borderRadius: 14,
  backgroundColor: "rgba(255,255,255,0.12)",
  alignItems: "center",
  justifyContent: "center",
  zIndex: 2,
},

overdueBannerTitle: {
  color: "#fff",
  fontWeight: "800",
  fontSize: 14,
  marginLeft: 8,
},

overdueBannerText: {
  color: "#fff",
  fontSize: 13,
  lineHeight: 18,
  opacity: 0.95,
},

overdueBannerCTA: {
  marginTop: 12,
  backgroundColor: "#eb5757",
  borderRadius: 14,
  paddingVertical: 12,
  paddingHorizontal: 14,
  flexDirection: "row",
  alignItems: "center",
  justifyContent: "center",
},

overdueBannerCTAText: {
  color: "#fff",
  fontWeight: "800",
  fontSize: 14,
},
blockingOverlay: {
  flex: 1,
  backgroundColor: "rgba(0,0,0,0.85)",
  justifyContent: "center",
  alignItems: "center",
  paddingHorizontal: 14,
},

blockingCard: {
  width: "100%",
  maxWidth: 520,
  backgroundColor: "#0b0b0c",
  borderRadius: 18,
  padding: 18,
  borderWidth: 2,
  borderColor: "#eb5757",
},

blockingTitle: {
  color: "#fff",
  fontWeight: "800",
  fontSize: 15,
  marginLeft: 8,
},

blockingText: {
  color: "#fff",
  fontSize: 13,
  lineHeight: 18,
  opacity: 0.95,
},

blockingCTA: {
  marginTop: 14,
  backgroundColor: "#eb5757",
  borderRadius: 14,
  paddingVertical: 12,
  paddingHorizontal: 14,
  flexDirection: "row",
  alignItems: "center",
  justifyContent: "center",
},

blockingCTAText: {
  color: "#fff",
  fontWeight: "800",
  fontSize: 14,
},
recentProposalBadge: {
  position: 'absolute',
  bottom: 10,
  right: 10,
  backgroundColor: '#2563eb',
  paddingLeft: 5,
  paddingRight: 10,
  paddingVertical: 5,
  borderRadius: 999,
  flexDirection: 'row',
  alignItems: 'center',
  zIndex: 25,
},

recentProposalBadgeIcon: {
  width: 18,
  height: 18,
  borderRadius: 9,
  backgroundColor: '#fff',
  alignItems: 'center',
  justifyContent: 'center',
  marginRight: 6,
},

recentProposalBadgeIconText: {
  color: '#2563eb',
  fontSize: 11,
  fontWeight: '900',
  lineHeight: 14,
},

recentProposalBadgeText: {
  color: '#fff',
  fontWeight: '800',
  fontSize: 12,
  letterSpacing: 0.2,
},

recentProposalBadge: {
  position: 'absolute',
  bottom: 10,
  right: 10,
  backgroundColor: '#2563eb',
  paddingLeft: 5,
  paddingRight: 10,
  paddingVertical: 5,
  borderRadius: 999,
  flexDirection: 'row',
  alignItems: 'center',
  zIndex: 25,
},

recentProposalBadgeIcon: {
  width: 18,
  height: 18,
  borderRadius: 9,
  backgroundColor: '#fff',
  alignItems: 'center',
  justifyContent: 'center',
  marginRight: 6,
},

recentProposalBadgeIconText: {
  color: '#2563eb',
  fontSize: 11,
  fontWeight: '900',
  lineHeight: 14,
},

recentProposalBadgeText: {
  color: '#fff',
  fontWeight: '800',
  fontSize: 12,
  letterSpacing: 0.2,
},
proposalInboxSection: {
  width: '100%',
  marginBottom: 20,
  paddingHorizontal: 2,
},

proposalInboxHeader: {
  flexDirection: 'row',
  alignItems: 'center',
  backgroundColor: '#eff6ff',
  borderWidth: 1,
  borderColor: '#bfdbfe',
  borderRadius: 18,
  paddingVertical: 10,
  paddingHorizontal: 12,
  marginBottom: 10,
},

proposalInboxBell: {
  width: 34,
  height: 34,
  borderRadius: 22,
  backgroundColor: '#ffffff',
  alignItems: 'center',
  justifyContent: 'center',
  marginRight: 10,
  borderWidth: 1,
  borderColor: '#bfdbfe',
},

proposalInboxTitle: {
  color: '#111827',
  fontSize: 16,
  fontWeight: '500',
},

proposalInboxSub: {
  color: '#1e3a8a',
  fontSize: 12,
  fontWeight: '600',
  marginTop: 2,
},

proposalFeatureCard: {
  width: '100%',
  height: 170,
  borderRadius: 20,
  overflow: 'hidden',
  backgroundColor: '#000',
  position: 'relative',
  maxWidth: 600,
  alignSelf: 'center',
  borderWidth: 2,
  borderColor: '#2563eb',
  shadowColor: '#2563eb',
  shadowOffset: { width: 0, height: 6 },
  shadowOpacity: 0.16,
  shadowRadius: 14,
  elevation: 6,
},

proposalFeatureImage: {
  width: '100%',
  height: '100%',
  borderRadius: 18,
  resizeMode: 'cover',
},

proposalFeatureOverlay: {
  position: 'absolute',
  bottom: 0,
  left: 0,
  right: 0,
  paddingHorizontal: 14,
  paddingVertical: 18,
},

proposalFeatureKicker: {
  color: '#bfdbfe',
  fontSize: 11,
  fontWeight: '800',
  textTransform: 'uppercase',
  letterSpacing: 0.5,
  marginBottom: 4,
},

proposalFeatureTitle: {
  color: '#ffffff',
  fontSize: 22,
  fontWeight: '800',
},

proposalFeatureDate: {
  color: '#f3f3f3',
  fontSize: 15,
  fontWeight: '600',
  marginTop: 4,
},

proposalNotificationPill: {
  position: 'absolute',
  top: 10,
  left: 10,
  backgroundColor: '#ffffff',
  borderRadius: 999,
  paddingVertical: 6,
  paddingHorizontal: 10,
  flexDirection: 'row',
  alignItems: 'center',
  borderWidth: 1,
  borderColor: '#bfdbfe',
  zIndex: 20,
},

proposalNotificationText: {
  color: '#2563eb',
  fontSize: 12,
  fontWeight: '800',
},

proposalMiniBadge: {
  position: 'absolute',
  bottom: 10,
  right: 10,
  backgroundColor: '#2563eb',
  paddingLeft: 6,
  paddingRight: 10,
  paddingVertical: 5,
  borderRadius: 999,
  flexDirection: 'row',
  alignItems: 'center',
  zIndex: 25,
},

proposalMiniBadgeIcon: {
  color: '#ffffff',
  fontSize: 15,
  fontWeight: '900',
  marginRight: 5,
},

proposalMiniBadgeText: {
  color: '#ffffff',
  fontWeight: '700',
  fontSize: 16,
  letterSpacing: 0.2,
},
});

export default App;
